import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next"; 

import "./style.css";
import "./App.css";

import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home"; 
import About from "./components/About/About"; // Import classique
import Projects from "./components/Projects/Projects"; // Import classique
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [load, updateLoad] = useState(true);
const { i18n, t } = useTranslation(); // 2. Récupère l'instance i18n

  // 3. Synchronisation de la langue du document (SEO & Accessibilité)
  useEffect(() => {
    const currentLang = i18n.language ? i18n.language.split('-')[0] : 'fr';
    document.documentElement.lang = currentLang;
  }, [i18n.language]);

  useEffect(() => {
    const timer = setTimeout(() => updateLoad(false), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      
      <div className={`App ${load ? "loading" : "loaded"}`} id={load ? "no-scroll" : "scroll"}>
        <Navbar />

<main style={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
  <Routes>
    <Route
      path="/"
      element={
        <div className="page-transition" style={{ flex: 1 }}>
          <Helmet>
            <title>Reda Mdair | Data Science</title>
                    <meta name="description" content="Spécialisé en Data Science, Reda Mdair allie rigueur mathématique et ingénierie, avec déploiement de solutions de la conception jusqu'à l'interface." />
                    <link rel="canonical" href="https://rmdair.com/" />
                  </Helmet>
                  <Home />
                </div>
              }
            />

            <Route
              path="/projects"
              element={
                <div className="page-transition">
                  <Helmet>
                    <title>{t("seo.projects_title")}</title>
                      <meta name="description" content="Sélection de travaux et réalisations techniques : résolution de problèmes complexes, optimisation et développement d'applications métiers." />
                    <link rel="canonical" href="https://rmdair.com/projects" />
                  </Helmet>
                  <Projects />
                </div>
              }
            />

            <Route
              path="/about"
              element={
                <div className="page-transition">
                  <Helmet>
                    <title>{t("seo.about_title")}</title>
                    <link rel="canonical" href="https://rmdair.com/about" />
                  </Helmet>
                  <About />
                </div>
              }
            />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;